/**
 * NATIVE_LOGS const symbols.
 * @constant
 * @type {Object}
 */


const NATIVE_LOGS = {
    CB_FN: 'cbfn',

    L_NON: 0,
    L_INFO: 3,
    L_ERROR: 5,
    INFO: 'Info',
    ERROR: 'Error'

};


export {NATIVE_LOGS};